<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-03-19 16:25:08
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-03-26 18:04:12
 * @FilePath: \miniproweb\src\views\ShowPdf\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div style="width:100vw;height:100vh">
    <pdf ref="pdf" :src="url" :page="numPages"></pdf>
    <!-- <pdf v-for="i in numPages" :key="i" :src="url" :page="i"></pdf> -->
    <div class="leftbox" @click="backpage">
      <van-icon name="arrow-left
" size="30px" />
    </div>
    <div class="rightBox" @click="nextpage">
      <van-icon name="arrow
" size="30px" />
    </div>
    <!-- <pdf :src="url" :page="1">
    <template slot="loading">
      loading content here...
    </template>
    </pdf>-->
  </div>
</template>

<script>
import pdf from "vue-pdf";
// import pdf from 'pdfvuer'
export default {
  components: {
    pdf
  },
  data() {
    return {
      url: "",
      numPages: 1,
      allpageNum: 1
    };
  },
  mounted() {
    // console.log(this.$route.params.url);
    this.url = this.$route.params.url;
    // this.getNumPages();
    // console.log(this.url);
    this.getNumPages(this.$route.params.url);
    console.log(pdf);
  },
  methods: {
    getNumPages(url) {
      var loadingTask = pdf.createLoadingTask(url);
      loadingTask.promise
        .then(pdf => {
          // this.url = loadingTask;
          console.log(pdf.numPages);
          // this.numPages = pdf.numPages;
          this.allpageNum = pdf.numPages;
        })
        .catch(err => {
          console.error("pdf加载失败");
        });
    },

    backpage() {
      if (this.numPages != 1) {
        this.numPages = this.numPages - 1;
      }
    },
    nextpage() {
      if (this.numPages != this.allpageNum) {
        this.numPages = this.numPages + 1;
      }
    }
  }
};
</script>

<style>
.leftbox {
  position: absolute;
  left: 0px;
  top: 50vh;
  z-index: 999;
  background-color: #6b6b6b63;
  width: 50px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0px 10px 10px 0px;
}
.rightBox {
  position: absolute;
  right: 0px;
  top: 50vh;
  z-index: 999;
  background-color: #6b6b6b63;
  width: 50px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px 0px 0px 10px;
}
</style>